<template>
  <div
    class="fixed top-0 bottom-0 overflow-scroll w-full h-full left-0 flex z-40 bg-black bg-opacity-50 transition ease-in-out duration-150"
  >
    <slot />
  </div>
</template>
